import { useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { FavoriteFolderResponse } from 'src/types/favorite';
import axiosInstance from 'src/utils/axios';

async function fetchFavoriteFolders(): Promise<FavoriteFolderResponse> {
  const res = await axiosInstance.get<FavoriteFolderResponse>(api.getFavoriteFolders);
  return res.data;
}

const useGetFavoriteFoldersQuery = (isEnabled: boolean) =>
  useQuery<FavoriteFolderResponse>({
    queryKey: [...queryKeys.favorite.folders()],
    queryFn: fetchFavoriteFolders,
    gcTime: 0,
    staleTime: 0,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    enabled: isEnabled,
  });

export default useGetFavoriteFoldersQuery;
